/* eslint-disable no-console */
import { useEffect } from 'react';
import { isGridApiValid } from '../utils/isGridApiValid';

export const useCloseColumnsPanelOnOutsideClick = (api, gridWrapperRef) => {
  useEffect(() => {
    if (!api || !gridWrapperRef?.current) return;

    const handleDocumentClick = (event) => {
      if (!isGridApiValid(api)) return;

      const wrapper = gridWrapperRef.current;
      if (!wrapper) return;

      const columnsPanel = wrapper.querySelector('.ag-column-panel');
      const sidebarButtons = wrapper.querySelector('.ag-side-buttons');

      if (!columnsPanel) return;
      if (columnsPanel.contains(event.target) || sidebarButtons?.contains(event.target)) {
        return;
      }

      try {
        if (typeof api.closeToolPanel === 'function') {
          api.closeToolPanel();
        }
      } catch (error) {
        console.warn('TableAgGrid: Error in useCloseColumnsPanelOnOutsideClick', error);
      }
    };

    document.addEventListener('mousedown', handleDocumentClick);
    document.addEventListener('touchstart', handleDocumentClick);

    return () => {
      document.removeEventListener('mousedown', handleDocumentClick);
      document.removeEventListener('touchstart', handleDocumentClick);
    };
  }, [api, gridWrapperRef]);
};
